import { PaysafeCardNumberFieldConfig } from './paysafe-field-card-number-config.interface';
import { PaysafeCvvFieldConfig } from './paysafe-field-cvv-config.interface';
import { PaysafeExpiryDateFieldConfig } from './paysafe-field-expiry-date-config.interface';

export interface PaysafeFieldsConfig {
  cardNumber: PaysafeCardNumberFieldConfig;
  cvv: PaysafeCvvFieldConfig;
  expiryDate: PaysafeExpiryDateFieldConfig;
}
